<template>
  <div>
    <el-upload
      ref="upload"
      class="upload-demo"
      :accept="accept"
      :multiple="multiple"
      :limit="limit"
      :show-file-list="false"
      action="uploadImgUrl"
      :before-upload="handleBeforeUpload"
      :http-request="handleUpload"
      :on-exceed="handleExceed"
      :on-change="handleChange"
    >
      <div
        class="uploadCellimg"
        :style="{
          width: `${width}px`,
          height: `${height}px`,
        }"
      >
        <i class="el-icon-plus"></i>
        <span>{{ tip }}</span>
      </div>
    </el-upload>
  </div>
</template>

<script>
import HTTPREQUEST from "@/config/app";
export default {
  name: "UploadImg",
  props: {
    tip: {
      type: String,
      default: "上传活动照片",
    },
    height: {
      type: Number,
      default: 140,
    },
    width: {
      type: Number,
      default: 140,
    },
    borderRadius: {
      type: Number,
      default: 6,
    },
    limit: {
      type: Number,
      default: 20,
    },
    path: {
      type: String,
      default: "conference/album",
    },
    accept: {
      type: String,
      default: ".jpg,.jpeg,.png,.JPG,.JPEG,.PNG,.avif,.jfif",
    },
    size: {
      type: String,
      default: "800x450",
    },
    multiple: {
      //多选
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      headers: {},
      filePath: {},
      fileList: [],
      uploadList: [],
      num: 0,
      baseUrl: "",
      process: 0,
      uploadImgUrl: "", // 上传的图片服务器地址
    };
  },
  created() {
    this.baseUrl = HTTPREQUEST.HTTPREQUESTURL;
    this.uploadImgUrl = HTTPREQUEST.HTTPREQUESTURL + "/apvi/upload/oss/image";
    this.headers = { Authorization: "Bearer " + this.$store.state.token };
  },
  methods: {
    handleChange(file, fileList) {
      this.$emit('handleChange',file.raw)
      // this.getImageSize(file.raw);
    },
  
    clear() {
      this.$refs.upload.clearFiles();
    },
    handleExceed(file, fileList) {
      this.$message.error({
        message: `文件个数不能超过${this.limit}个`,
        showClose: true,
        type: "error",
      });
    },
    //手动上传的方法
    handleUpload(op) {
      let that = this;
      let dir = that.path;
      that.$oss.bucketUpload(
        op.file,
        (res) => {
          that.$emit("UploadSuccess", res);
          this.num--;
          if (this.num <= 0) this.clear();
        },
        (err) => {
          that.$message.error({
            message: err,
            showClose: true,
            type: "error",
          });
        },
        (progress) => {
          that.$emit("UploadProgress", progress);
        },
        dir,
        that.accept.includes(".jpg") ? "image" : "video"
      );
    },
    // 上传前loading加载
    handleBeforeUpload(file) {
      let data = {
        uid: file.uid,
        name: file.name,
        progress: 0,
        type: this.accept.includes(".jpg") ? "image" : "video",
        size: file.size,
      };
      this.$emit("handleBeforeUpload", data);
      this.num++;
    },
  },
};
</script>

<style lang="scss" scoped>
.uploadCellimg {
  background: #fbfbfb;
  border-radius: 6px 6px 6px 6px;
  border: 1px dashed #d5d8df;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  i {
    font-size: 30px;
    color: #a5abb7;
  }
  span {
    font-size: 14px;
    color: #a5abb7;
    margin-top: 10px;
  }
}
</style>
